import defaultGuard from './default/guard'

const guards = [
  defaultGuard
]

export default guards
